// extracted by mini-css-extract-plugin
export default {"root":"VBX4z9","checkbox":"UIrYCS","checkboxError":"H7Za8Y"};